// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'molitorItalic', 'molitorItalic Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_054f94","variable":"__variable_054f94"};